export default class Brands {
    constructor() {
        this.el = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.hideDeleted();
    }
    hideDeleted() {
        /*
        if we want to delete brands after wards, we comment out the items in Listpresets.js
        if a customer opens the sidebar, then internally the misc-field in the database
        removes the brand and it is no longer visible after the next publish.
        
        for existing pages, that are already published and in the editor without opening the sidebar
        we use the following function that deletes brands, that should be removed.
        */

        [56, 64].forEach((deleted_brands__value) => {
            if (
                this.el.querySelector(
                    '.brands__list-item[data-preset-id="' + deleted_brands__value + '"]'
                ) !== null
            ) {
                this.el
                    .querySelector(
                        '.brands__list-item[data-preset-id="' + deleted_brands__value + '"]'
                    )
                    .remove();
            }
        });
    }
}
